import { render, staticRenderFns } from "./video-3d-slider.vue?vue&type=template&id=289a0c52&scoped=true"
import script from "./video-3d-slider.vue?vue&type=script&lang=js"
export * from "./video-3d-slider.vue?vue&type=script&lang=js"
import style0 from "./video-3d-slider.vue?vue&type=style&index=0&id=289a0c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a0c52",
  null
  
)

export default component.exports